import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import SafeHTML from '../fw/SafeHTML.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'organisationNotificationView.title', 'defaultMessage': 'Notification'}
});

interface OrganisationNotificationViewProps {
    intl: IntlShape;
    user: User;
}

class OrganisationNotificationView extends React.Component<OrganisationNotificationViewProps> {

    typeName = 'organisationNotifications';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const data = this.props.user.organisation.notification;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <DetailBox data={data} metadata={type} urlMapping={urlMapping}>
                    <DetailToolBar data={data} metadata={type} organisationId={this.props.user.organisation.realId} urlMapping={urlMapping}>
                    </DetailToolBar>

                    <h2>{data.name}</h2>

                    <TableDetail columns={{
                        'createdAt': {},
                        'recipients': {
                            render: (column, value) => {
                                if (value) {
                                    return JSON.parse(value).join(", ");
                                }

                                return "";
                            }
                        },
                        'flowDef.name': {},
                        'flow.flowTitle': {},
                    }} data={data} metadata={type} />

                    <div style={{"padding": "2em"}}>
                        <SafeHTML value={data.body} />
                    </div>
                </DetailBox>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(OrganisationNotificationView), (props) => {
    return props.user.organisation && props.user.organisation.notification;
}), {
    initialVariables: {
        organisationId: '',
        notificationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    notification(id: $notificationId) {
                        organisation_id,
                        id,
                        subject,
                        createdAt,
                        body,
                        recipients,
                        template,
                        flow_id,
                        flow {
                            id,
                            realId,
                            flowTitle,
                            name,
                        },
                        flowDef_id,
                        flowDef {
                            id,
                            name,
                        },
                    }
                }
            }
        `,
    },
});
